import React from 'react';
import { Grid } from '@mui/material';
import { Field } from 'formik';
import i18n from 'i18n-js';
import { CreditTypeSelect } from 'components/AsyncFields';

const CreditTypeInputs = (errors) => {
  return (
    <Grid item xs={12} sx={{ maxWidth: '35rem', margin: 'auto' }}>
      <Grid container spacing={2}>
        <Grid item size={{ xs: 6, md: 6 }}>
          <Field
            firstLoad
            margin="none"
            name="invoice_item_type_id"
            id="credit_type_select"
            component={CreditTypeSelect}
            asyncErrors={errors?.invoice_item_type_id}
            label={i18n.t('promo_codes.credit_type')}
            required
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export { CreditTypeInputs };
